import * as _ from 'lodash';

export class Auth {
  _id: number;
  name: string;
  email: string;
  mobile: string;
  role: string;
  authenticated = false;


  constructor(auth?: {
    id: number;
    name: string;
    email: string;
    role: string;
    mobile: string;
  }) {
    if (auth) {
      _.assignIn(this, auth);
      this.authenticated = true;
    } else {
      this.authenticated = false;
    }
  }
}
